<template>
    <!--弹窗-->
    <el-dialog width="600px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" label-width="180px" size="mini">
            <div class="top">
                <div style="font-weight: 900;">下载模板</div>
                <div>
                    <a href="/export/自动否定无效词根模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“自动否定无效词根”模板</a>
                </div>
            </div>
            <div class="download">
                <el-upload
                    class="upload-demo"
                    drag
                    action="/"
                    accept=".xls, .xlsx"
                    ref="upload"
                    :file-list="files"
                    :http-request="handleUpload"
                    :on-exceed='handExceed'
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :limit="1"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__text" style="font-size: 12px;margin-top: 5px;">只能上传.xls/.xlsx文件</div>
                </el-upload>
            </div>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :disabled="disabled">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/etyma/etyma";
import { binary_download } from "@/utils/method";
export default {
    data() {
        return {
            files: [],
            disabled: false
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        handleUpload(raw) {
            this.files.push(raw.file);
        },
        handExceed(files, fileList) {
            this.$message({
                type: "warning",
                message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
            });
            return;
        },
        handFileSuccess() {
            this.files = [];
            this.$refs.upload.clearFiles();
        },
        handleRemove(file, fileList) {
            this.files = fileList;
        },
        // 保存信息
        submitForm() {
            this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
            if (this.files.length == 0) {
                this.$message.warning(`当前限制只能上传选择 1 个文件`);
                return;
            }
            let file = new FormData();
            file.append("file", this.files[0]);
            let obj = {
                asin: this.formData.parent_asin,
                state: this.formData.state
            };
            this.disabled = true;
            api.auto_negate_etyma(obj, file)
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "上传成功",
                            type: "success"
                        });
                        binary_download(
                            "/apis/v1/common_file_export_by_path",
                            "post",
                            {},
                            {
                                file_path: res.data
                            },
                            "application/vnd.ms-excel",
                            `${
                                this.formData.parent_asin
                            }-自动否定无效词根分析文件.xlsx`
                        );
                        this.disabled = false;
                        this.handleClose();
                    } else {
                        this.disabled = false;
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        // 关闭弹窗
        handleClose() {
            this.handFileSuccess();
            this.$refs["formData"].resetFields();
            this.$emit("close-callback", true);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
